module.exports = __webpack_public_path__ + "media/images/skills_banner_bg_sa-fb3e3676.png";